// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { ICoordinatesSchema } from './CoordinatesSchema';

export interface IInfrastructurePinForMapSchema {
  /** Координаты объекта инфраструктуры **/
  coordinates: ICoordinatesSchema;
  /** Идентификатор объекта инфраструктуры **/
  id: string;
  /** Наименование объекта инфраструктуры **/
  title: string;
  /** Тип объекта инфраструктуры **/
  type: EType;
}

export enum EType {
  /** Поликлиника **/
  'Clinic' = 'clinic',
  /** Продуктовый магазин **/
  'Grocery' = 'grocery',
  /** Станция метро **/
  'Metro' = 'metro',
  /** Детский сад **/
  'Nursery' = 'nursery',
  /** Школа **/
  'School' = 'school',
}
